import type { LineItem } from "~/features/cart/cart/models/CartData";

export function isCartPackEntryValid(entry: LineItem) {
  return (
    entry.quantity > 0 &&
    // !!entry.packSize &&
    Number.isInteger(entry.quantity / (entry.packSize ?? 1)) &&
    !!entry.deliveryDate &&
    (!entry.contractErrorMessage ||
      (entry.contractErrorMessage.type !== "fatal" && entry.contractErrorMessage.type !== "error")) &&
    !entry.messages.some((msg) => msg.type === "fatal" || msg.type === "error")
  );
}

export function isQuotePackEntryValid(entry: LineItem) {
  return (
    entry.quantity > 0 &&
    // && !!entry.packSize
    Number.isInteger(entry.quantity / (entry.packSize ?? 1)) &&
    !!entry.deliveryDate
  );
}
